module.exports = __webpack_public_path__ + "img/automobile.d20fc2c5.gif";